<!-- Prikazi listu fizickih lica sa sve search-om -->
<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="fizickaLicaTable"
    [chipItems]="chipItems"
    [isTableLoading]="isLoading"
  >
  </kodit-table>
</kodit-page>
